import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
} from 'react-admin';

const InAppNotificationList = props => (
  <List {...props} sort={{ field: 'createdAt', order: 'DESC' }}>
    <Datagrid optimized>
      <TextField source="message" label="Description" />
      <NumberField source="reachCount" label="Хэдэн хүнд хүрсэн" />
      <NumberField source="contentTypeEvent" label="Хэрэглэгчийн төхөөрөмж" />
      <DateField source="createdAt" label="Хэзээ илгээгдсэн" showTime />
    </Datagrid>
  </List>
);

export {
  InAppNotificationList,
}; 